// Copyright (c) 2026 Query Health Inc. All rights reserved.
// Author: Shubham Dixit <shubham@quantinohealth.com>
// Licensed under a Commercial License. See LICENSE for terms.

import { type ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '@/context/auth-context'
import AppLoader from '@/components/AppLoader'
import AccessDenied from '@/components/AccessDenied'

// Gates provider routes: shows the loader while auth state resolves, redirects
// unauthenticated users to /login (preserving where they were headed), and
// shows AccessDenied for a signed-in user whose account isn't provisioned for
// any org (bootstrap returned no role).
export default function RequireAuth({ children }: { children: ReactNode }) {
  const { user, role, loading } = useAuth()
  const location = useLocation()

  if (loading) return <AppLoader />
  if (!user) return <Navigate to="/login" replace state={{ from: location }} />
  if (!role) return <AccessDenied />
  return <>{children}</>
}
